export function allowReactContentPreview(toolCall: any): boolean {
  const isReactContent =
    toolCall.content?.panel?.contentType === 'application/vnd.aha.react';
  const isNotPreparing = toolCall.status !== 'preparing';
  const allowsScriptableArtifacts =
    window.currentAccount?.aiAllowScriptableArtifacts || false;

  return allowsScriptableArtifacts && (!isReactContent || isNotPreparing);
}
